/* src/components/block-signal/block-signal.component.scss */
app-block-signal {
  display: block;
}
.block-signal {
  position: relative;
  padding: 2rem 1.5rem;
  border-radius: var(--vwui--radius--md);
  box-shadow: var(--vwui-shadow-base);
  background: var(--vwui-color-neutral-3);
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.block-signal__summary {
  -webkit-user-select: none;
  user-select: none;
}
.block-signal__value {
  display: inline-block;
  vertical-align: bottom;
  line-height: 0.6;
  font-weight: 500;
  font-size: 2rem;
}
.pdf-page .block-signal__value {
  font-size: 1.8rem;
}
.block-signal__label {
  font-weight: 500;
  font-size: 0.85rem;
  line-height: 1;
  opacity: 0.35;
  margin: 0.6rem 0 0 0;
}
/*# sourceMappingURL=block-signal.component-P627YAT3.css.map */
